<template>
	<div
		class="g-block-pay-jumplink-unlock"
		:class="{
			'g-block-pay-jumplink-unlock--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-unlock--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-unlock__card">
			<div class="g-block-pay-jumplink-unlock__top">
				<div class="g-block-pay-jumplink-unlock__info">
					<p class="g-block-pay-jumplink-unlock__title">{{ data.title || '解锁完整内容' }}</p>
					<div class="g-block-pay-jumplink-unlock__assurance">
						<i class="mbm-iconfont mbm-iconfontanquan" :style="{ color: btnColor }"></i>
						<span>{{ data.assuranceText || '支付成功后自动跳转' }}</span>
					</div>
				</div>
				<div class="g-block-pay-jumplink-unlock__price-wrap">
					<span  v-if="!isGeditModulePaid && !shouldHidePrice"  class="g-block-pay-jumplink-unlock__promo">{{ data.promoTag || '限时特价' }}</span>
					<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-unlock__price">
						<span class="g-block-pay-jumplink-unlock__currency">¥</span>
						<span class="g-block-pay-jumplink-unlock__integer">{{ priceParts.integer }}</span>
						<span class="g-block-pay-jumplink-unlock__decimal">{{ priceParts.decimal }}</span>
					</span>
				</div>
			</div>
			<div class="g-block-pay-jumplink-unlock__divider"></div>
			<div
				class="g-block-pay-jumplink-unlock__btn"
				:style="buttonStyle"
				@click.stop="onButtonClick"
			>
				<span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '支付并立即跳转' }}</span>
				<span class="g-block-pay-jumplink-unlock__btn-arrow">
					<i class="mbm-iconfont mbm-youjiantou1" :style="{ color: btnColor }"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor, getButtonStyle } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_UNLOCK } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkUnlock',
		mixins: [payUnlockMixin],
		computed: {
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_UNLOCK);
			},
			buttonStyle() {
				return {
					...getButtonStyle(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_UNLOCK),
					color: '#fff',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_UNLOCK.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
		},
		methods: {
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkUnlock: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-unlock {
		&--edit {
			border: 1px solid transparent;
			border-radius: 20px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-pay-jumplink-unlock__card {
		background: #fff;
		border-radius: 12px;
		padding: 20px 18px 16px;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
	}

	.g-block-pay-jumplink-unlock__top {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 12px;
	}

	.g-block-pay-jumplink-unlock__info {
		min-width: 0;
		flex: 1;
	}

	.g-block-pay-jumplink-unlock__title {
		margin: 0;
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		color: #1a1a1a;
	}

	.g-block-pay-jumplink-unlock__assurance {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-top: 10px;
		font-size: 13px;
		color: #333;
		line-height: 1.3;

		.mbm-iconfont {
			flex-shrink: 0;
			font-size: 18px;
		}

		span {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.g-block-pay-jumplink-unlock__price-wrap {
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 4px;
	}

	.g-block-pay-jumplink-unlock__promo {
		display: inline-flex;
		align-items: center;
		padding: 2px 8px;
		border-radius: 999px;
		background: #ff2b2b;
		color: #fff;
		font-size: 11px;
		line-height: 1.3;
		font-weight: 500;
	}

	.g-block-pay-jumplink-unlock__price {
		display: inline-flex;
		align-items: flex-end;
		color: #ff2b2b;
		font-weight: 700;
		line-height: 1;
	}

	.g-block-pay-jumplink-unlock__currency {
		font-size: 16px;
		margin-right: 2px;
		margin-top: 10px;
	}

	.g-block-pay-jumplink-unlock__integer {
		font-size: 36px;
		letter-spacing: -1px;
	}

	.g-block-pay-jumplink-unlock__decimal {
		font-size: 16px;
		margin-top: 4px;
	}

	.g-block-pay-jumplink-unlock__divider {
		margin: 16px 0;
		height: 1px;
		background: #eef0f4;
	}

	.g-block-pay-jumplink-unlock__btn {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 48px;
		border-radius: 10px;
		font-size: 16px;
		font-weight: 600;
		line-height: 1;
		cursor: pointer;
		user-select: none;
	}

	.g-block-pay-jumplink-unlock__btn-arrow {
		position: absolute;
		right: 14px;
		top: 50%;
		transform: translateY(-50%);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: #fff;

		.mbm-iconfont {
			font-size: 25px;
		}
	}

	.g-block-pay-jumplink-unlock--h5 {
		.g-block-pay-jumplink-unlock__card {
			border-radius: 0.24rem;
			padding: 0.4rem 0.36rem 0.32rem;
			box-shadow: 0 0 0.24rem rgba(0, 0, 0, 0.1);
		}

		.g-block-pay-jumplink-unlock__top {
			gap: 0.24rem;
		}

		.g-block-pay-jumplink-unlock__title {
			font-size: 0.44rem;
		}

		.g-block-pay-jumplink-unlock__assurance {
			gap: 0.12rem;
			margin-top: 0.2rem;
			font-size: 0.26rem;

			.mbm-iconfont {
				font-size: 0.36rem;
			}
		}

		.g-block-pay-jumplink-unlock__price-wrap {
			gap: 0.08rem;
		}

		.g-block-pay-jumplink-unlock__promo {
			padding: 0.04rem 0.16rem;
			font-size: 0.22rem;
		}

		.g-block-pay-jumplink-unlock__currency {
			font-size: 0.32rem;
			margin-top: 0.2rem;
		}

		.g-block-pay-jumplink-unlock__integer {
			font-size: 0.72rem;
		}

		.g-block-pay-jumplink-unlock__decimal {
			font-size: 0.32rem;
			margin-top: 0.08rem;
		}

		.g-block-pay-jumplink-unlock__divider {
			margin: 0.32rem 0;
		}

		.g-block-pay-jumplink-unlock__btn {
			height: 0.96rem;
			font-size: 0.32rem;
			border-radius: 0.2rem;
		}

		.g-block-pay-jumplink-unlock__btn-arrow {
			right: 0.28rem;
			width: 0.6rem;
			height: 0.6rem;

			.mbm-iconfont {
				font-size: 0.5rem;
			}
		}
	}
</style>
